<div class="absence-interval-calendar px-2 pb-4">
    <div class="text-sm text-secondary mb-2">{{ 'services.absences.intervalCalendar' | transloco }}</div>
    <div class="flex flex-col sm:flex-row sm:items-center gap-4">
        <div class="w-fit rounded-lg border border-gray-200 p-2 dark:border-gray-700">
            <div class="flex items-center justify-between">
                <button mat-icon-button type="button" (click)="previousMonth()" [disabled]="!canGoPrevious()">
                    <mat-icon svgIcon="mat_outline:chevron_left"></mat-icon>
                </button>
                <span class="text-sm font-medium">{{ monthLabel() }}</span>
                <button mat-icon-button type="button" (click)="nextMonth()" [disabled]="!canGoNext()">
                    <mat-icon svgIcon="mat_outline:chevron_right"></mat-icon>
                </button>
            </div>
            <mat-calendar [startAt]="activeDate" [minDate]="rangeStart" [maxDate]="rangeEnd" [selected]="null"
                [dateClass]="dateClass" (selectedChange)="ignoreSelection()"></mat-calendar>
        </div>
        <div class="flex flex-col gap-2 text-sm">
            <div class="flex items-center gap-2">
                <span class="absence-swatch absence-swatch-applies"></span>
                {{ 'services.absences.legendApplies' | transloco }}
            </div>
            @if (hasWeekDays()) {
                <div class="flex items-center gap-2">
                    <span class="absence-swatch absence-swatch-excluded"></span>
                    {{ 'services.absences.legendExcluded' | transloco }}
                </div>
            }
            @if (hasCanceled()) {
                <div class="flex items-center gap-2">
                    <span class="absence-swatch absence-swatch-canceled"></span>
                    {{ 'services.absences.legendCanceled' | transloco }}
                </div>
            }
        </div>
    </div>
</div>
